"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isPrimitiveObject(value) {
    if (!value || typeof value !== 'object')
        return false;
    return value instanceof String || value instanceof Number || value instanceof Boolean;
}
function isDeepEqual(input1, input2) {
    const stepEqual = (a, b) => {
        if (typeof a !== 'object' || typeof b !== 'object')
            return a === b;
        if (!a || !b)
            return a === b;
        if (isPrimitiveObject(a) || isPrimitiveObject(b)) {
            return Object.getPrototypeOf(a) === Object.getPrototypeOf(b) && String(a) === String(b);
        }
        const isArray1 = Array.isArray(a);
        const isArray2 = Array.isArray(b);
        if (isArray1 !== isArray2)
            return false;
        // TODO: consider looping object?
        const keys1 = Object.keys(a);
        const keys2 = new Set(Object.keys(b));
        if (keys1.length !== keys2.size)
            return false;
        for (let i = 0; i < keys1.length; i++) {
            const key = keys1[i];
            if (!keys2.has(key))
                return false;
            const ak = a[key];
            const bk = b[key];
            if (!stepEqual(ak, bk))
                return false;
        }
        return true;
    };
    return stepEqual(input1, input2);
}
exports.default = isDeepEqual;
